import React, { FC, useEffect } from 'react'
import { navigate } from 'gatsby'
import Authentication, { AuthenticationType } from './Authentication'

const RedirectComponent: FC = () => {
	const { authenticationSignin }: AuthenticationType = Authentication()

	useEffect(() => {
		// Guard against an immediate auto-login right after an explicit logout.
		// SignOutButton sets 'logoutInProgressAt' before calling MSAL logoutRedirect.
		// If this component mounts within 15 seconds of that timestamp it means the
		// B2C redirect cycle just completed and we should NOT re-trigger a sign-in;
		// instead redirect to the home page as a clean unauthenticated landing.
		const logoutInProgressAt = localStorage.getItem('logoutInProgressAt')

		if (logoutInProgressAt) {
			const elapsedMs = Date.now() - Number(logoutInProgressAt)

			if (!Number.isNaN(elapsedMs) && elapsedMs < 15000) {
				// Still within the post-logout window – clear the flag and go home.
				localStorage.removeItem('logoutInProgressAt')
				navigate('/')
				return
			}

			// Flag is stale (> 15s) – discard it and proceed normally.
			localStorage.removeItem('logoutInProgressAt')
		}

		// No recent logout detected: trigger the normal B2C sign-in redirect.
		authenticationSignin()
	}, [])

	return null
}

export default RedirectComponent
